/**
 * Local Persistence Service for Saved Illustrations in rn-equote
 * Delegates storage operations to illustrationRepository (Drizzle ORM + IndexedDB).
 */
import { illustrationRepository, type IllustrationRecord } from '../repositories';
import { formatDate } from '../core/datetime';

export interface SavedIllustration {
  id: string;
  proposalName: string;
  customerName: string;
  customerAge: number;
  customerGender: 'Nam' | 'Nữ';
  sumAssured: string;
  premium: string;
  freq: string;
  term: string;
  selectedRiders: string[];
  topUpAmount: number;
  topUpStartYear?: number;
  topUpDuration?: number;
  r5Mode?: 'complimentary' | 'attached';
  createdAt: string;
  updatedAt: string;
  created_at?: string;
  updated_at?: string;
  stage: 'new' | 'negotiating' | 'closed';
  customerId?: string;
}

export const getSavedIllustrationsAsync = async (): Promise<SavedIllustration[]> => {
  const records = await illustrationRepository.getAll();
  return records.map((item) => ({
    id: item.id,
    proposalName: item.proposalName,
    customerName: item.customerName,
    customerAge: item.customerAge,
    customerGender: item.customerGender,
    sumAssured: item.sumAssured,
    premium: item.premium,
    freq: item.freq,
    term: String(item.term),
    selectedRiders: item.selectedRiders,
    topUpAmount: item.topUpAmount || 0,
    createdAt: item.lastUpdated,
    updatedAt: item.lastUpdated,
    stage: item.stage,
    customerId: item.customerId,
  }));
};

export const getSavedIllustrations = (): SavedIllustration[] => {
  let cached: SavedIllustration[] = [];
  getSavedIllustrationsAsync().then((res) => {
    cached = res;
  });
  return cached;
};

export const saveIllustrationLocal = (
  data: Omit<SavedIllustration, 'id' | 'createdAt' | 'updatedAt' | 'created_at' | 'updated_at' | 'stage'>
): SavedIllustration => {
  const dateStr = formatDate(new Date());

  const customerId = data.customerId || `KH-${Math.floor(1000 + Math.random() * 9000)}`;

  illustrationRepository.save({
    customerId,
    proposalName: data.proposalName,
    productCode: 'XUM',
    customerName: data.customerName,
    customerAge: data.customerAge,
    customerGender: data.customerGender,
    sumAssured: data.sumAssured,
    term: parseInt(data.term, 10) || 20,
    freq: data.freq,
    premium: data.premium,
    stage: 'new',
    lastUpdated: dateStr,
    expiryDate: 'Tự động gia hạn',
    selectedRiders: data.selectedRiders,
    topUpAmount: data.topUpAmount,
  });

  return {
    ...data,
    id: `ILL-SAVED-${Date.now()}`,
    createdAt: dateStr,
    updatedAt: new Date().toISOString(),
    stage: 'new',
    customerId,
  };
};

export const deleteSavedIllustrationLocal = (id: string): SavedIllustration[] => {
  illustrationRepository.delete(id);
  return [];
};
